import _ from 'lodash';

export const getOpportunitiesFromState = state => state.opportunities;

export const getOpportunitySelector = (state, { opportunityId }) =>
    _.get(state, `opportunities`, []).find(x => x.opportunityId === opportunityId);
